import { useContext } from "react";
import UserContext from "../../context/user";
import CartContext from "../../context/cart";

const CartDelivered = () => {
  const { userProfile } = useContext(UserContext);
  const { labels } = useContext(CartContext);

  return (
    <div className="wrapper wrapper-small">
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{
          __html: (
            labels?.WELFARE_CART_DELIVERED ||
            "<p><strong>Ciao [USER]</strong><br/>Il tuo carrello risulta consegnato. Buone feste!</p>"
          ).replace(
            "[USER]",
            `<span translate="no">${userProfile?.firstName} ${userProfile?.lastName}</span>`
          ),
        }}
      />
      <div
        className="carrello-content__text carrello-content__text--border-top"
        dangerouslySetInnerHTML={{
          __html:
            labels?.WELFARE_CONTACT_US_INFO ||
            "<p>Per ulteriori informazioni:<br/><strong>Welfare EssilorLuxottica</strong><br/><a href='mailto:welfare@essilorluxottica.com'>welfare@essilorluxottica.com</a></p>",
        }}
      />
    </div>
  );
};

export default CartDelivered;
